import * as React from "react";
import { PageContainer } from "../../src/Basic/PageContainer";
import TranslateWrapper from "../../src/i18n/TranslateWrapper";
import dynamic from "next/dynamic";
import { GetStaticProps } from "next";
import { fetchTranslates } from "../../lib/Storyblok/fetchTranslation";
const CurrentUserHistoryPage = dynamic(
  () => import("../../src/User/History/AccountHistoryPage"),
  {
    ssr: false,
  }
);
//購買記錄
export default function AccountHistoryRoute() {
  return (
    <PageContainer>
      <TranslateWrapper ns="checkout">
        <CurrentUserHistoryPage></CurrentUserHistoryPage>
      </TranslateWrapper>
    </PageContainer>
  );
}

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {
  const translate = await fetchTranslates(
    ["commontranslate", "my-library-translate", "checkout-translate"],
    locale
  );
  return {
    props: {
      translate,

      // dict: productDict,
    },
  };
};
